import React from 'react'

// Keep this in sync with api/app/Rules/Standard.php.
const screenNamePattern = /^[\x5B\x5Da-zA-Z0-9-./\\\t: ,!$#?()&+{|}<=>@^_:%§"]*$/

export const isValidScreenTitle = (title = '') => {
  return screenNamePattern.test(title)
}

export const pathValidator = (itemArray, itemType) => {
  // we should at least validate no duplicate paths are included. 
  const paths = itemArray.map(item => item.path)
  const distinctPaths = [...new Set(paths)]

  if (paths.length === distinctPaths.length) {
    // if the two arrays are the same length thing there were no duplicate paths.
    return false
  }

  // if there were duplicate paths now we need to do the work of finding them and warning the user. 
  const duplicatePaths = {}
  paths.forEach(currentPath => {
    if (duplicatePaths[currentPath] != null) {
      // this path is duplicated but we have already calculated its count.
      return
    }
    let cnt = 0
    paths.forEach(possibleMatch => {
      if (possibleMatch === currentPath) {
        cnt++
      }
    })
    if (cnt > 1 && !duplicatePaths[currentPath]) {
      duplicatePaths[currentPath] = 2
    } else if (cnt > 1) {
      duplicatePaths[currentPath]++
    }
  })

  if (Object.keys(duplicatePaths).length === 0) {
    return false
  } else {
    // if there were errors, return jsx <li> item list elements for display in the validation error
    return (<>{Object.keys(duplicatePaths).map((path, idx) => <li key={idx}>{`Path ${path} is being used by ${duplicatePaths[path]} ${itemType}s. Each ${itemType} must have a unique path.`}</li>)}</>)
  }
}

export const screenTitleValidator = (screens = []) => {
  const errors = []

  screens.forEach((screen, idx) => {
    const title = screen?.name
    const titleLabel = `Screen ${idx + 1}`

    if (typeof title !== 'string' || title.trim() === '') {
      errors.push(`${titleLabel} must include a title.`)
      return
    }

    if (!isValidScreenTitle(title)) {
      errors.push(
        `${titleLabel} title contains unsupported characters. Allowed characters are letters, numbers, spaces, and common punctuation (backtick, single quote, and tilde are not allowed).`
      )
    }
  })

  return errors
}